import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import classnames from 'classnames'
import { useTheme } from '@homebot/shared-ui-swashbuckle'

// Components
import { Button, Text, If, Unless } from '../../../..'
import {
  IconThumbsUp,
  IconThumbsDown,
  IconWrench,
} from '../../../Icon'

// Styles
import baseStyles from '../Chart.module.scss'
import styles from './ThumbsUpAndDownOption.module.scss'

const propTypes = {
  handleThumbsUpClick: PropTypes.func.isRequired,
  handleThumbsDownClick: PropTypes.func.isRequired,
  showAnsweredMessage: PropTypes.bool,
  lowConfidence: PropTypes.bool,
  handleTuneYourValue: PropTypes.func,
}

const ThumbsUpAndDownOption = ({
  handleThumbsUpClick,
  handleThumbsDownClick,
  showAnsweredMessage,
  lowConfidence,
  handleTuneYourValue,
}) => {
  const { theme } = useTheme()

  return (
    <>
      <Text
        weight='semibold'
        upperspaced
        variant='neutralCool'
        variantCount='900'
        className={classnames(baseStyles.title, styles.title)}
      >
        <Unless condition={showAnsweredMessage}>
          <FormattedMessage
            id='Homeowner.estimatedValue.lowConfidenceWarning.avmHotMarket.title'
            defaultMessage='Quick check:'
          />
        </Unless>
        <If condition={showAnsweredMessage && lowConfidence}>
          <FormattedMessage
            id='Homeowner.estimatedValue.lowConfidenceWarning.thumbsDown.title'
            defaultMessage='No worries'
          />
        </If>
      </Text>

      <Text
        size='xs'
        variant='neutralCool'
        variantCount='700'
        className={classnames(baseStyles.describe, styles.describe)}
      >
        <Unless condition={showAnsweredMessage}>
          <FormattedMessage
            id='Homeowner.estimatedValue.lowConfidenceWarning.avmHotMarket.subTitle'
            defaultMessage='Does your value seem right?'
          />
        </Unless>
        <If condition={showAnsweredMessage && lowConfidence}>
          <FormattedMessage
            id='Homeowner.estimatedValue.lowConfidenceWarning.thumbsDown.subTitle'
            defaultMessage="Let's change it together!"
          />
        </If>
      </Text>

      <Button.Group
        className={classnames(
          styles.buttonGroup,
          theme.isLightThemeType && styles.lightThemeButtonGroup
        )}
      >
        <Unless condition={showAnsweredMessage}>
          <Button
            data-qa='thumbs-up-btn'
            iconStart={IconThumbsUp}
            onClick={handleThumbsUpClick}
          />
          <Button
            data-qa='thumbs-down-btn'
            iconStart={IconThumbsDown}
            onClick={handleThumbsDownClick}
          />
        </Unless>
        <If condition={showAnsweredMessage && lowConfidence}>
          <Button
            iconStart={IconWrench}
            onClick={handleTuneYourValue}
            data-qa='low-confidence-tune-value-btn'
          >
            <FormattedMessage
              id='Homeowner.estimatedValue.lowConfidenceWarning.tuneBtn'
              defaultMessage='Tune your value'
            />
          </Button>
        </If>
      </Button.Group>
    </>
  )
}

ThumbsUpAndDownOption.propTypes = propTypes

export default ThumbsUpAndDownOption
